import {LayoutType} from '@wandb/weave/common/types/media';

// Global configurable
export const MAX_COL_COUNT = 20;
export const MIN_COL_COUNT = 1;
export const MAX_RUNS_PERF_WARNING_THRESHOLD = 150;
export const DEFAULT_MAX_Y_AXIS_COUNT = 30;
export const DEFAULT_LAYOUT_TYPE: LayoutType = 'ALL_STACKED';

export const MAXIMUM_MEDIA_PANEL_IMAGE_COUNT = 32;
